/**
 * FacetWP pagination
 */
var component_facetwp_pagination = function(args) {

  // setup args
  var pagination = args.pagination;

  if (pagination) {
    (function($) {
      $(document).on('facetwp-refresh', function() {
        if ( FWP.soft_refresh == true ) {
            FWP.enable_scroll = true;
        } else {
            FWP.enable_scroll = false;
        }
      });
      $(document).on('facetwp-loaded', function() {
          if ( FWP.enable_scroll == true ) {
            $('html, body').animate({
              scrollTop: $('.teasers').offset().top - 100
            }, 500);
          }
      });

      $(document).on('facetwp-loaded', function() {
        // Add proper aria-labels to pagination next and previous links
        setTimeout(() => { // needed because apparently FacetWP modifies the DOM even after the loaded event
          let next = pagination.querySelector('.facetwp-page.next');
          let previous = pagination.querySelector('.facetwp-page.prev');
          if (next) {
            next.setAttribute('aria-label', theme_strings.next_page);
            next.innerHTML = '<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="30.812" height="50.771" viewBox="0 0 30.812 50.771"><path d="M218.392,122.886a2.784,2.784,0,0,1-3.944,0l-2.634-2.634a2.783,2.783,0,0,1-.005-3.939l17.907-17.992L211.809,80.33a2.789,2.789,0,0,1,.005-3.944l2.634-2.634a2.784,2.784,0,0,1,3.944,0l22.6,22.595a2.8,2.8,0,0,1,0,3.949Z" transform="translate(-210.995 -72.934)" fill="#133030"/></svg></span>';
          }
          if (previous) {
            previous.setAttribute('aria-label', theme_strings.prev_page);
            previous.innerHTML = '<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="30.811" height="50.771" viewBox="0 0 30.811 50.771"><g transform="translate(30.811 50.771) rotate(180)"><path d="M218.392,122.886a2.784,2.784,0,0,1-3.944,0l-2.634-2.634a2.783,2.783,0,0,1-.005-3.939l17.907-17.992L211.809,80.33a2.789,2.789,0,0,1,.005-3.944l2.634-2.634a2.784,2.784,0,0,1,3.944,0l22.6,22.595a2.8,2.8,0,0,1,0,3.949Z" transform="translate(-210.995 -72.934)" fill="#133030"/></g></svg></span>';
          }
        }, 0)
      });
    })(jQuery);
  }

  // make the call chainable
  return this;

};

